import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";

const ProtectedRoute = ({
  children,
  component: Component,
  fallBack = "/",
  ...rest
}) => {
  const isSelected = useSelector(
    (state) => state?.user?.selectedSamverkanspart
  );

  return (
    <Route
      {...rest}
      render={(props) => {
        return isSelected ? (
          Component ? (
            <Component {...props} />
          ) : (
            children
          )
        ) : (
          <Redirect
            to={{
              pathname: fallBack,
              state: {
                from: props.location,
              },
            }}
          />
        );
      }}
    />
  );
};

export default ProtectedRoute;
